import api from '../core/api';

const findAll = async () => {
  const result = await api.get('/coupons');
  const coupons = result.data;
  return coupons;
};

export default {findAll};
